import Player from '@vimeo/player';
import EmbeddedConcentElement from '../EmbeddedConcentElement/EmbeddedConcentElement';

class IframeVimeo extends EmbeddedConcentElement {

  // constructor done by parent class
  //  constructor() { }

  initElement() {

    this.videoId = this.getAttribute('video-id')
    this.videoKey = this.getAttribute('video-key')
    this.defaultCover = this.getAttribute('default-cover')
    this.posterUrl = this.defaultCover

    fetch(`https://vimeo.com/api/v2/video/${this.videoId}.json`)
      .then(response => response.json())
      .then(data => {
        iframeContainer.querySelector(".iframe__img").src = data[0].thumbnail_large
      })

    this.posterMarkup = `<figure class="iframe__poster figure-gradient">
      <img
        src="${this.posterUrl}"
        width="1280"
        height="720"
        alt=""
        class="iframe__img"
        loading="lazy">
      <button
        class="button iframe__play"
        type="button"
        value="Play Video"
      >
      <svg class="icon icon-play" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M0 5C0 2.23858 2.23858 0 5 0H35C37.7614 0 40 2.23858 40 5V35C40 37.7614 37.7614 40 35 40H5C2.23858 40 0 37.7614 0 35V5Z" fill="currentColor"/>
      <path d="M13 13.8777C13 12.4507 14.529 11.5477 15.779 12.2347L27.319 18.5817C28.614 19.2937 28.614 21.1547 27.319 21.8677L15.78 28.2147C14.53 28.9017 13.001 27.9977 13.001 26.5717L13 13.8777Z" fill="black"/>
      </svg>
        <span class="visually-hidden">Play Vimeo Video</span>
      </button>
    </figure>`;

    // Create a shadow root
    //const shadow = this.attachShadow({mode: 'open'});

    const iframeContainer = document.createElement('div');
    iframeContainer.setAttribute('class', 'iframe-container');

    // Create player element
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', `player-${this.videoKey}`);
    iframeContainer.appendChild(wrapper);

    iframeContainer.insertAdjacentHTML("beforeend", this.posterMarkup)

    this.appendChild(iframeContainer);


    this.player = new Player(`player-${this.videoKey}`, {
      id: this.videoId,
      width: 640
    });

    this.playButton = this.querySelector(".iframe__play")
    this.poster = this.querySelector(".iframe__poster")

    this.playButton.addEventListener("click", evt => {
      evt.preventDefault()
      this.poster.classList.add("iframe__poster--playing")
      this.player.play()
    })

    this.player.on("ended", () => {
      this.poster.classList.remove("iframe__poster--playing")
    });
  }
}

export default IframeVimeo
